module.exports = __webpack_public_path__ + "assets/img/AIF-Social-Static-Ad.c2f111bc.webp";